import { currencyFormatter } from './currencyFormatter.js';

/**
 * Berechnet den Grand Total basierend auf der aktuellen Order-Struktur.
 *
 * @param {Order} order - Die aktuelle Order, die alle Subitems und Preise enthält.
 * @returns {string} - Der formatierte Grand Total als String.
 */
export function calculateGrandTotal(order) {

  let grandTotal = 0.00;
  // Durchlaufe alle Subitems und summiere die Totals
  if (order?.subitem_prices && order.subitem_prices.length > 0) {
    order.subitem_prices.forEach(item => {
      grandTotal += item.total;
    });
  }
  // console.trace(order);
  // console.trace(grandTotal);

  // Aktualisiere das Grand Total Element in der UI
  const grandTotalElement = document.getElementById('grand-total');
  if (grandTotalElement) {
    grandTotalElement.innerHTML = currencyFormatter(grandTotal / 100);
  }

  // hide PayPal-buttons if grandTotal <= 0
  const paypalButtonContainer = document.getElementById('paypal-pay-container');
  if (grandTotal > 0) {
    paypalButtonContainer.classList.remove('hidden');
  } else {
    paypalButtonContainer.classList.add('hidden');
  }

  // Rückgabe des Grand Totals als formatierten String
  return (grandTotal / 100).toFixed(2);
}
